export const DOCUMENT_REF_TYPE = {
  contract: 1,
  payment: 2,
};

export const DOCUMENT_STATUS = {
  İptal: 1,
  Revizyonda: 2,
  Yayında: 3,
  Onayda: 4,
};

export const DOCUMENT_LANGUAGE = { Türkçe: 1, İngilizce: 2 };
